import { BaseTableRequest, TableResponse } from 'types'
import axiosInstance from './axios'
import { AdminSearchResult } from 'types/admin.types'

export interface AdminGlobalSearchRequestWithDate extends BaseTableRequest {
  params: {
    searchText: string
    fromDate?: string
    toDate?: string
  }
}

export const adminGlobalSearch = async (
  request: AdminGlobalSearchRequestWithDate,
): Promise<TableResponse<AdminSearchResult>> => {
  return axiosInstance.post('/admin/global-search', request)
}
